var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.42 14.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.26,3.14c.16-1.31.33-2.45-.16-3.1S19,6.56,16.51,6.72a13.37,13.37,0,0,0-4.24,1l-3.91.49s.33,2.44-.48,2.28-3.1-2-4.24-2.93S2.34,3.3,1.36,3C.23,2.6.71,8,.06,8.68s4.56,4.07,5.37,4.23S24.49,15,25.79,13.4s-1.3-4.24-1-6.35S27.1,4.44,27.26,3.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe);
export default __webpack_public_path__ + "static/media/PE.d30ab96568a515ea9d1342819ceeb61c.svg";
export { ForwardRef as ReactComponent };